import React from 'react';
import clsx from 'clsx';
import { makeStyles } from '@mui/styles';
import CircularProgress from '@mui/material/CircularProgress';
import { orange } from '@mui/material/colors';
import Button from '@mui/material/Button';

const useStyles = makeStyles((theme) => ({

  wrapper: {
    margin: theme.spacing(1),
    position: 'relative',
  },
  buttonSuccess: {
    backgroundColor: orange[500],
    '&:hover': {
      backgroundColor: orange[700],
    },
  },
  buttonProgress: {
    color: orange[500],
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
  button: {
    height: '36px',
    borderRadius: 30,
    fontSize: '11px',
  },
}));

export default function ButtonLoad({
  text, size, color, variant, onClick, loading, disabled, success, type, ...other
}) {
  const classes = useStyles();

  const buttonClassName = clsx({
    [classes.buttonSuccess]: success,
  });

  return (
    <div className={classes.wrapper}>
      <Button
        variant={variant || 'contained'}
        size={size || 'large'}
        color={color || 'primary'}
        onClick={onClick}
        {...other}
        classes={{ root: classes.button }}
        className={buttonClassName}
        disabled={loading || disabled}
        disableElevation
        type={type}
      >
        {text}
      </Button>
      {loading && <CircularProgress size={24} className={classes.buttonProgress} />}
    </div>
  );
}
